function validateInteger(int) {
  var re = /^[0-9\b]+$/;
  return re.test(int);
}
export default validateInteger;
